// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2-35S","cell":"ColumnAccessor_cell__1okJl","firstCellAccent":"ColumnAccessor_firstCellAccent__Ol4bT"};